import { Pagination } from "react-bootstrap";

export default function TablePagination({ renderElements, elements, page, setPage, perPage }) {
    const pages = Math.ceil(renderElements()
        .length / perPage);

    return <div className="custom-pagination-container">
        <Pagination className="justify-content-center custom-pagination m-0">
            <span className="mx-2 pagination-text"> {renderElements().slice((page - 1) * perPage, page * perPage).length} - Lignes par page {(page - 1) * perPage + 1}–
                {Math.min(page * perPage, elements.length)} / {renderElements().length}</span>
            <Pagination.First onClick={() => setPage(1)} />
            <Pagination.Prev
                onClick={() => setPage(page - 1 < 1 ? 1 : page - 1)}
            />
            <Pagination.Next onClick={() => setPage(page + 1 > pages ? pages : page + 1)} />
            <Pagination.Last onClick={() => setPage(pages)} />
        </Pagination>
    </div>
}